import * as React from "react";
import { useFormApi, useFormState, useFieldState } from "informedv4";
import { ConfigFieldDropdown } from "../../forms/informedv4/ConfigFieldDropdownV4";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { ConfigFieldTimePicker } from "../../forms/informedv4/ConfigFieldTimePickerV4";
import { Required } from "../../forms/validation/Required";
import { SubjectAlarms } from "./SubjectAlarms";
import { Site, Language } from "webportalclient";
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { SubjectFormModel } from "../SubjectsShared";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

interface SubjectEdiaryFormBodyProps {
    sites: Site[];
    enabled: boolean;
    onSetLimitedLanguages: React.Dispatch<React.SetStateAction<Language[]>>
    subjectLimitedLanguages: Language[];
}

export const SubjectEdiaryFormBody = ({ sites, enabled, onSetLimitedLanguages, subjectLimitedLanguages }: SubjectEdiaryFormBodyProps) => {
    const { languages, studySubjectSetting } = useCurrentStudyConfigurationContext();
    const formApi = useFormApi();
    const formState = useFormState();
    const { value: siteId } = useFieldState('SiteId');

    React.useEffect(() => {
        if (!enabled)
            return;

        const site = sites.find(s => s.id === formState.values.SiteId);
        if (site) {
            if (studySubjectSetting?.limitSubjectLanguageSelectionToSiteCountry) {
                onSetLimitedLanguages(languages.filter(x => x.localeName.endsWith(site.country)))
                if (subjectLimitedLanguages.length != 0 && !subjectLimitedLanguages.some(x => x.id == formState.values.LanguageId))
                    formApi.setValue('LanguageId', undefined);
            } else {
                onSetLimitedLanguages(languages);
            }
        } else {
            if (studySubjectSetting?.limitSubjectLanguageSelectionToSiteCountry) {
                onSetLimitedLanguages([])
            } else {
                onSetLimitedLanguages(languages);
            }
        }
    }, [enabled, sites, siteId]);

    if (!enabled) return null;

    return (
        <>
            <div className="row">
                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="Pin">PIN</label>
                    <TextBox name="Pin" id="Pin" field="Pin" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>

                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="PinConfirmation">PIN Confirmation</label>
                    <TextBox name="PinConfirmation" id="PinConfirmation" field="PinConfirmation" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>
                <div className="form-group col-sm-4 col-xs-12">
                    <ConfigFieldTimePicker
                        id="BedTime"
                        field="BedTime"
                        name="Bed Time"
                        placeholder="HH:mm (24 hour format)"
                        itemId={ConfigurableDataItemIds.BedTime}
                    />
                </div>
            </div>
            <div className="row">
                <ConfigFieldDropdown
                    name="LanguageId"
                    id="Language"
                    field="LanguageId"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    required={true}
                    itemId={ConfigurableDataItemIds.SubjectLanguage}
                >
                    {
                        subjectLimitedLanguages.map(so => (
                            <option
                              key={`Option${so.localeName}`}
                              value={so.localeName}
                            >
                                {so.name}
                            </option>
                        ))}
                </ConfigFieldDropdown>
            </div>

            <SubjectAlarms />

        </>
    );
}
